import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { MouseEvent, ReactElement, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { useLoader } from '../../../helpers/useLoader';
import { Home } from '../../../routes/config/Home';
import { IAnnotationCreationService } from '../annotationCreation.service';
import { IAnnotationsStore } from '../annotations.store';
import { SaveDraftAnnotationsModal } from '../components/SaveDraftAnnotationsModal';
import { IUndoRedoHistory } from '../undoRedoHistory.service';

export const BackToProjectsButtonWithDraftContainer = observer((): ReactElement => {
  const history = useHistory();
  const historyService = useInjection(IUndoRedoHistory.$);
  const annotationCreationService = useInjection(IAnnotationCreationService.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const annotationsStore = useInjection(IAnnotationsStore.$);

  const { t } = useTranslator();
  const { isLoading, withLoaderAsync } = useLoader();
  const [showModal, setShowModal] = useState(false);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleClick = (event: MouseEvent): void => {
    event.preventDefault();
    if (annotationsStore.image === undefined || !historyService.canUndo) {
      handleCancel();
    } else {
      setShowModal(true);
      setConfirmedNavigation(false);
    }
  };

  const handleCancel = (): void => {
    historyService.clearHistory();
    setShowModal(false);
    setConfirmedNavigation(true);
    history.push(Home.Projects.List.All.withParams({ workspaceId: currentWorkspaceStore.currentWorkspace.id }));
  };

  const handleToggle = (): void => {
    setShowModal(false);
  };

  const handleConfirm = async (): Promise<void> => {
    await withLoaderAsync(async () => await annotationCreationService.safelyLeaveAnnotationAsync());
    historyService.clearHistory();
    setShowModal(false);
    setConfirmedNavigation(true);
    history.push(Home.Projects.List.All.withParams({ workspaceId: currentWorkspaceStore.currentWorkspace.id }));
  };

  const handleBlockedNavigation = (): boolean => {
    if (!confirmedNavigation && historyService.canUndo) {
      setShowModal(true);
      return false;
    }

    return true;
  };

  return (
    <>
      <Button
        tabIndex={-1}
        onClick={handleClick}
        color='neutral'
        variant='topbar'
        startDecorator={<FontAwesomeIcon icon={faArrowLeft} />}
      >
        {t('back')}
      </Button>
      <Prompt
        when={true}
        message={handleBlockedNavigation}
      />
      <SaveDraftAnnotationsModal
        isOpen={showModal}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        onToggle={handleToggle}
        isLoading={isLoading}
      />
    </>
  );
});
